import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobConversations } from '../api/jobDetailApi';

export function useJobConversations(jobId: number) {
  return useQuery({
    queryKey: [...queryKeys.jobs.detail(String(jobId)), 'conversations'],
    queryFn: () => getJobConversations(jobId),
    enabled: jobId > 0,
  });
}
